export const TAB_IDS = {
  RESULTS: "results",
  APPROVERS: "approvers"
};
